export const conditionalRender = <T>(condition: boolean, renderer: T) =>
  condition ? renderer : undefined

export const valueOrDefault = <T>(value: T | undefined, defaultValue: T): T =>
  value === undefined ? defaultValue : value

const isDefined = <T>(value: T | undefined): value is T => value !== undefined && value !== null

export const valueRender = <T>(
  value: T | undefined,
  renderer?: (value: T) => string,
  defaultValue = '-'
) => (!isDefined(value) ? defaultValue : renderer ? renderer(value) : (value?.toString() ?? ''))
